import { barcodeLabelTemplateSchema } from "@redotech/redo-inventory-common/barcode-label-builder/barcode-label-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getBarcodeLabelTemplate = {
  name: "getBarcodeLabelTemplate" as const,
  input: z.object({ templateId: zExt.objectId() }),
  output: z.object({ template: barcodeLabelTemplateSchema }),
};
